export enum UmpireImageOrientation {
  DEFAULT = 'default',
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export interface ImageOrientationOption {
  id: UmpireImageOrientation;
  name: string;
}
